<template>
  <q-ajax-bar position="top" ref="bar" size="5px" :delay="delay" color="$secondary" />
  <q-header reveal elevated class="bg-white text-black">
    <q-toolbar>
      <q-icon name="img:/assets/images/icon/ico_home.svg" :onclick="onClickHome" style="width: 2.4vw; height: 2.4vw; cursor: pointer" />
      <div style="display: flex; margin-left: 20px;">
        <q-btn flat icon="arrow_back_ios_new" :onClick="() => { nextExam(true); }" />
        <q-select filled v-model="model" use-input hide-selected fill-input input-debounce="0" :options="options"
          @filter="filterFn" style="width: 250px; ">
          <template v-slot:no-option>
            <q-item>
              <q-item-section class="text-grey">
                No results
              </q-item-section>
            </q-item>
          </template>
        </q-select>
        <q-btn flat icon="arrow_forward_ios" :onClick="() => { nextExam(); }" />
      </div>
    </q-toolbar>
  </q-header>
  <q-page-container v-show="!isLoading">
    <ul class="qlist">
      <div class="question" v-html="questionHeader"></div>
      <li class="list_item" v-for="(item, index) in data">
        <div style="display: flex;flex-direction: row;">
          <div style="display: flex;flex-direction: column;width: 100%">
            <div style="display: flex;flex-direction: row;width: 100%;justify-content: space-between;">
              <div style="display: flex;">
                <div class="number">
                  <div v-show="complete" :class="[item.correct ? 'marking-correct' : 'marking-wrong']" />
                  {{ index + 1 }}.
                </div>
                <div style="font-size: 1.4em;" v-html="item.problems"></div>
              </div>
              <div class="icon_box">
                <div :class="[answer &&
                answer.filter((item) => item.index === index + 1 && item.checked === '①').length > 0
                ? 'checked' : 'icon_circle']" @click="selectAnswer(index + 1, '①')">
                  <q-icon name="radio_button_unchecked" size="4em"
                    :class="[answer && answer.filter((item) => item.index === index + 1 && item.checked === '①').length > 0 ? 'checkedicon' : 'uncheckedicon']" />
                </div>
                <div :class="[answer &&
                answer.filter((item) => item.index === index + 1 && item.checked === '②').length > 0
                ? 'checked' : 'icon_circle']" @click="selectAnswer(index + 1, '②')">
                  <q-icon name="close" size="4em"
                    :class="[answer && answer.filter((item) => item.index === index + 1 && item.checked === '②').length > 0 ? 'checkedicon' : 'uncheckedicon']" />
                </div>
              </div>
            </div>
            <div class="check_answer" v-show="complete">
              <div style="display: flex; flex-direction: row;align-items: center;">
                <span style="font-weight: 700;font-size: 1.2em">정답</span>
                <div class="checked_small">
                  <q-icon v-if="item.answer === '①'" name="radio_button_unchecked" size="1em" class='checkedicon' />
                  <q-icon v-if="item.answer === '②'" name="close" size="1em" class='checkedicon' />
                </div>
              </div>
              <div style="margin-top: 10px;">
                <span style="font-weight: 700;font-size: 1.2em">해설</span>
                <span style="margin-left: 10px;font-size: 1.2em" v-html="item.explain"></span>
              </div>
            </div>
          </div>
        </div>
        <div class="divider" />
      </li>
    </ul>
    <!-- <q-footer bordered class="bg-white text-primary"> -->
    <!-- <div class="bottom_buttons">
        <div style="display: flex; flex-direction: row; width: 10%; justify-content: space-between;">
          <button class="button_icon">
            <q-icon name="chevron_left" size="3em" style="color: #fff" />
          </button>
          <button class="button_icon">
            <q-icon name="chevron_right" size="3em" style="color: #fff" />
          </button>
        </div>
      </div> -->
    <!-- </q-footer> -->
  </q-page-container>
  <!-- </q-layout> -->
  <modalLayer v-if="store.visibleModal" :width="'30%'">
    <div class="popup">
      <h5 style="font-weight: 700">어휘학습 완료!</h5>
      <img src="@/assets/images/ready.png" style="width: 70%;margin-top: 20px" />
      <div style="font-size: 1.2em">다음은 비문학-지문2의 </div>
      <div style="font-size: 1.2em">코어독해 학습을 시작합니다.</div>
      <button class="move_to_core" @click="moveToCoreReading">코어독해 시작</button>
    </div>
  </modalLayer>
</template>

<script setup>
import { historyBack } from "@/helpers/utils"
import splash from "@/components/template/splash.vue"
import { ref, onMounted, onUnmounted, watch } from "vue";
import studyHeader from "@/components/layouts/header/studyHeader.vue";
import { useQuasar } from 'quasar'
import { useRouter } from "vue-router"
import { getKrtExam, getKrtProblem } from "@/api/modules/qbank";
import dataToParse from "@/helpers/qbankParser/dataParse";
import moment from "moment";
import modalLayer from '@/components/layouts/layer/modalLayer.vue';
import { DialogStore } from "@/store/modules/dialog";
import { getHeader, getQuestion, getQuestion_old, getAnswerExplain } from "@/helpers/qbankParser/qbankDataParse";
import { stripTags } from "@amcharts/amcharts5/.internal/core/util/Utils";
import { StudyStore } from "@/store/modules/study";
import { examsData } from "@/views/testPage/examsData";
import _ from "lodash"

const router = useRouter();

const loadingTime = 1000;
const isLoading = ref(null);
const delay = 0;
const bar = ref(null)
const answer = ref([]);
const complete = ref(false)
const $q = useQuasar();
const isVisiblePopup = ref(false)
const store = DialogStore();
const studyStore = StudyStore();

const data = ref(null)
const questionHeader = ref(null);

let noti = null;
let problemMaps = [];
let temp = [];
let i = 0

let stage = '' // start, check, done

const styletag = (text) => {
  if (text) {
    let result = dataToParse.transferStyleTag(text).replace(/<(CHAR size\="14.3")>/g, '')
      .replace(/<(\/CHAR)>/g, '').replace(/<(\/TEXT)>/g, '').replace(/<(TEXT)>/g, '').replace('<보기>', '').replace('→', '<br/> <span style="margin-left: 30px;">→<span>')
    return result;
  }
}

const initVoca = (rs) => {
  console.log('init', rs.content);
  console.log(getQuestion(rs));
  let value = {
    question: getHeader(rs, true),
    problems: getQuestion_old(rs),
    answer: rs.content.solution.answer.detail[0].answer,
    explain: getAnswerExplain(rs)
    // problems: styletag(dataToParse.getQuestionBody(rs)[0][0].content),
    // answer: dataToParse.getAnswer(rs)[2].content,
    // explain: dataToParse.getAnswerExplain(rs)[0][0].content
  }

  temp.push(value)
  if (temp.length === 4) {
    data.value = temp;
    isLoading.value = false;
  }
  // data.value = temp;
  // questionHeader.value = dataToParse.getQuestionHeader(rs);
  questionHeader.value = stripTags(getHeader(rs, true));

  // console.log('temp', temp)

}

const testPaper = () => {

  let newData = []

  data.value.map((item, index) => {
    answer.value.map((ans) => {
      // console.log('answer', ans)
      if (index === ans.index - 1) {
        if (item.answer === ans.checked) {
          // console.log('correct', item.answer, ans.checked)
          let temp = {
            ...item,
            correct: true
          }
          return newData.push(temp)
        } else {
          // console.log('wrong', item.answer, ans.checked)
          let temp = {
            ...item,
            correct: false
          }
          return newData.push(temp)
        }
      }
    })
    // console.log(newData)
  })

  data.value = newData;

  if (answer.value.length === data.value.length) {
    complete.value = true
    noti = $q.notify({
      color: 'light-blue-7',
      textColor: 'white',
      multiLine: true,
      position: 'bottom-right',
      badgeStyle: { display: 'none' },
      timeout: 0,
      actions:
        [{ label: '개념이해 완료', color: 'white', handler: () => showPopup() }]
    })
  }
  return;
}

const showPopup = () => {
  // isVisiblePopup.value = true
  // store.openModal(true)
  console.log(showPopup);
  console.log(studyStore.mapTree.exams.length);
  console.log(studyStore.process.examIdx);
  if (studyStore.mapTree.exams.length > studyStore.process.examIdx) {
    // 다음 지문으로 이동
    studyStore.setNextProcess();
    moveToCoreReading();
    // studyStore.process = { exam: studyStore.mapTree.exams[studyStore.process + 1], examIdx: studyStore.process + 1, studyTree: 5082, problemOrd: 0, isDone: false }
  } else if (studyStore.mapTree.exams.length === studyStore.process.examIdx) {
    // TODO: 학습 완료 프로세스 진행
  }

}

const moveToCoreReading = () => {
  router.push("/corereading")
}

const selectAnswer = (index, checked) => {
  stage.value === 'check'
  let answerlist = []
  let data = {
    index,
    checked
  }

  if (complete.value === true) {
    return
  }

  // o가 선택된 상황에서 x를 선택한 경우, 반대 경우
  if (answer.value.length > 0 && answer.value.filter((item) => item.index === index).length > 0) {
    if (checked === '①') {
      let newAnswer = answer.value.map((item) => {
        if (item.index === index) {
          return {
            index: item.index,
            checked: '①'
          }
        }
        return item
      })
      answer.value = [...newAnswer]

    } else {
      let newAnswer = answer.value.map((item) => {
        if (item.index === index) {
          return {
            index: item.index,
            checked: '②'
          }
        }
        return item
      })
      answer.value = [...newAnswer]

    }
  } else {
    // o, x 둘 중 하나를 선택한 경우
    answerlist.push(data)
  }
  answer.value = [...answer.value, ...answerlist]

  console.log(JSON.parse(JSON.stringify(answer.value)))
}

onMounted(() => {
  isLoading.value = true;
  const barRef = bar.value;
  barRef.start()
  stage.value === 'start'

  setTimeout(() => {
    if (barRef) {
      barRef.stop()
    }
    isLoading.value = false;
  }, loadingTime)

  setTimeout(() => {
    $q.notify({
      color: '#44444490',
      textColor: 'white',
      position: 'right',
      timeout: 1000,
      // message: '어휘력 실력을 키워보아요!'
      message: '수능 빈출 어휘 문제를 풀어 보세요.'
    })
  }, [2000])


  // getKrtExam({
  //   version: studyStore.exprVersion, examNm: studyStore.process.exam.examCode + '_W'
  // }, (rs) => {
  //   // console.log('exam:', rs)

  //   if (rs.examMaps) {
  //     const exId = rs.examIds[0];
  //     problemMaps = rs.examMaps[exId];
  //     problemMaps.map((item) => {
  //       getKrtProblem({
  //         version: studyStore.exprVersion, problemId: item.problemId
  //       }, initVoca)
  //     })
  //   }
  // });

})

watch((answer), () => {
  if (answer.value.length === data.value.length) {
    $q.notify({
      color: '#44444490',
      textColor: 'white',
      position: 'right',
      badgeStyle: { display: 'none' },
      timeout: 1000,
      message: '문제를 다 풀었어요!'
    })
    noti = $q.notify({
      timeout: 0,
      message: '',
      multiLine: true,
      badgeStyle: { display: 'none' },
      color: 'deep-orange-6',
      position: 'bottom-right',
      actions:
        [{ label: '정답 확인', color: 'white', iconRight: 'arrow_forward_ios', handler: () => testPaper() }]
    });
  }
})

const model = ref(null);

watch(() => model.value, (newValue) => {
  isLoading.value = true;
  temp = [];
  data.value = null;
  getKrtExam({
    version: studyStore.exprVersion, examNm: newValue + '_W'
  }, (rs) => {
    // console.log('exam:', rs)

    if (rs.examMaps) {
      const exId = rs.examIds[0];
      problemMaps = rs.examMaps[exId];
      problemMaps.forEach((item, index) => {
        // problemMaps.map((item, i) => {
        getKrtProblem({
          version: studyStore.exprVersion, problemId: item.problemId
        }, initVoca)
      });


    }
  });
});

onUnmounted(() => {
  isLoading.value = true;
  noti !== null && noti();
})

const options = ref(stringOptions);

const stringOptions = examsData;
model.value = stringOptions[0];

const filterFn = (val, update, abort) => {
  update(() => {
    const needle = val.toLowerCase()
    options.value = [...stringOptions].filter(v => v.toLowerCase().indexOf(needle) > -1)
  })
}

const nextExam = (back = false) => {
  console.log('@@@@@@@@@@@@@@@@@@@@@@@@@@@ ');
  console.log(stringOptions);
  console.log(model.value);
  // const fIndex = stringOptions.findIndex((e, i) => { e === model.value });
  const fIndex = _.findIndex(stringOptions, function (o) { return o === model.value; });
  console.log(fIndex);
  if (back) {
    if (fIndex !== 0)
      model.value = stringOptions[fIndex - 1]
  } else {
    if (fIndex !== stringOptions.length - 1)
      model.value = stringOptions[fIndex + 1]
  }
}

const onClickHome = () => {
  store.openConfirmDialog({
    message: '중단하고 홈으로 이동하시겠습니까?',
    cancel: '닫기',
    ok: '확인',
    callback: () => { router.push('/learninghome') },
  });
}
</script>

<style scoped lang="scss">
.question {
  // margin-left: 120px;
  font-size: 1.5em;
  font-weight: 700;
  // margin-top: 30px;
}

.qlist {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 40px 120px;
  height: 80%;
}

.list_item {
  display: flex;
  flex-direction: column;
  padding-top: 20px;

  .number {
    justify-content: center;
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: bold;
    margin-right: 24px;
  }
}

.icon_box {
  display: flex;
  flex-direction: row;
}

.icon_circle {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  border: 1px solid #bbbbbb60;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 20px;
}

.divider {
  width: 100%;
  height: 1px;
  background-color: $divider;
  margin-top: 20px;
}

.bottom_buttons {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 60px;
  justify-content: center;
  align-items: center;
}

.button_icon {
  width: 40px;
  height: 40px;
  background-color: #bbbbbb70;
  border-radius: 50%;
}

.check_answer {
  width: 100%;
  background-color: $gray_200;
  border-radius: 16px;
  margin-top: 24px;
  padding: 20px;
}

.checked {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  border: 1px solid #bbbbbb60;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 20px;
  background-color: $primary;
}

.move_to_core {
  background-color: $primary;
  padding: 10px 16px;
  border-radius: 20px;
  color: $white;
  margin-top: 20px;
  font-weight: 600;
}

.checked_small {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid #bbbbbb60;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 10px;
  background-color: $primary;
}

.checkedicon {
  color: #fff;
}

.uncheckedicon {
  color: #d9d9d9
}

.popup {
  width: 100%;
  background-color: $white;
  border-radius: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 50px 25px;
  min-height: 460px;
  max-height: 550px;
}

.marking {

  &-correct {
    background-image: url('@/assets/images/O.png');
    background-position: 50%;
    background-size: cover;
    width: 50px;
    height: 40px;
    position: absolute;
    z-index: 100;
    margin-left: 0px;
  }

  &-hcorrect {
    background-image: url('@/assets/images/OX.png');
    background-position: 50%;
    background-size: cover;
    width: 50px;
    height: 40px;
    position: absolute;
    z-index: 100;
    margin-left: 0px;
  }

  &-wrong {
    background-image: url('@/assets/images/X.png');
    background-position: 50%;
    background-size: cover;
    width: 50px;
    height: 40px;
    position: absolute;
    z-index: 100;
    margin-left: 0px;
  }

  &-fwrong {
    background-image: url('@/assets/images/XX.png');
    background-position: 50%;
    background-size: cover;
    width: 50px;
    height: 40px;
    position: absolute;
    z-index: 100;
    margin-left: 0px;
  }
}
</style>
